'use client';

import styles from "./AIStickyBar.module.css";
import Link from "next/link";
import { MessageCircle, Sparkles } from "lucide-react";

export default function AIStickyBar() {
  return (
    <Link
      href="https://ai.temok.com"
      target="_blank"
      className={`${styles.wrapper} text-decoration-none`}
    >
      <div className={styles.bar}>

        {/* LEFT */}
        <div className={styles.left}>
          <div className={styles.icon}>
            <Sparkles size={14} className="text-white"/>
          </div>
          <span className={`text-decoration-none textHad fs-6 fw-semibold lh-base`}>
            Ask Temok AI
          </span>
        </div>

        {/* RIGHT */}
        {/* <div className={styles.cta}>
          Chat Now
          <MessageCircle size={16} />
        </div> */}

      </div>
    </Link>
  );
}